import { SET_DONE_WITH_ACTIONS as type } from './';

export default payload => ({
  type,
  payload,
});
